export const APPLICATION = {"PROD":true,"DEV":false};
export const PRODUCT = 'club1';

const PRODUCTS = {
  club1: {
    product: 'club1',
    title: 'Club #1',
    description: 'Club #1 — manage your club, teams, trainings, and members efficiently.',
    themeColor: '#1976d2',
    favicon32: '/assets/app-icons/icon-32x32.png',
    appleTouchIcon: '/assets/app-icons/icon-192x192.png',
    apiProdUrl: 'https://clubone.uno:9999/api',
    apiDevUrl: 'http://localhost:8621/api',
    botProdUsername: 'clubnumberone_bot',
    botDevUsername: 'clubonedev_bot',
  },
  course1: {
    product: 'course1',
    title: 'Course #1',
    description: 'Course #1 — manage courses, students, lessons, and progress.',
    themeColor: '#6f42c1',
    favicon32: '/assets/app-icons/icon-32x32.png',
    appleTouchIcon: '/assets/app-icons/icon-192x192.png',
    apiProdUrl: 'https://course1.uno:9999/api',
    apiDevUrl: 'http://localhost:8621/api',
    botProdUsername: 'coursenumberone_bot',
    botDevUsername: 'courseonedev_bot',
  },
};

const currentProduct = PRODUCTS[PRODUCT] || PRODUCTS.club1;

export const getProduct = () => currentProduct.product;
export const getProductTitle = () => currentProduct.title;
export const getDescription = () => currentProduct.description;
export const getThemeColor = () => currentProduct.themeColor;
export const getFavicon32 = () => currentProduct.favicon32;
export const getAppleTouchIcon = () => currentProduct.appleTouchIcon;

export const getBaseUrl = () => {
  if (APPLICATION.PROD) return currentProduct.apiProdUrl;
  return currentProduct.apiDevUrl;
};

export const botUsername = () => {
  if (APPLICATION.PROD) return currentProduct.botProdUsername;
  return currentProduct.botDevUsername;
};

export const isClub1 = () => getProduct() === 'club1';
export const isCourse1 = () => getProduct() === 'course1';